import { getCreateCreditTokenUrl } from "../shared/createCreditToken.utils.js";

export const buildPowerTranzRequest = (formData, props) => {
  const [cardExpiryMonth, cardExpiryYear] =
    formData.cardExpiryDate.split(" / ");

  return {
    fleetId: props.fleetId,
    userId: props.userId ?? props.i,
    userType: props.userType,
    returnUrl: props.returnUrl ?? props.u,
    transactionId: props.tranId,
    cardNumber: formData.cardNumber.replace(/\s+/g, ""),
    expiredDate: `${cardExpiryMonth}/20${cardExpiryYear}`,
    cvv: formData.cardCVC,
    cardHolder: formData.cardHolder,
    name: formData.cardHolder,
    street: formData.billingAddress,
    city: formData.billingCity,
    state: formData.billingState,
    postalCode: formData.billingPostal,
    country: formData.billingCountry,
    email: formData.billingEmail,
    phone: formData.billingPhone,
  };
};

export const getPowerTranzCreateTokenUrl = (baseUrl, userType) =>
  getCreateCreditTokenUrl(baseUrl, userType);

export const getPowerTranzRedirect = (apiResponse) => {
  const response = apiResponse?.response ?? apiResponse;
  const html = response?.bizContent ?? response?.RedirectData;
  const url = response?.["3ds_url"] ?? response?.url3ds;
  const isRedirectResponse =
    Boolean(html || url) &&
    (!response?.IsoResponseCode ||
      response.IsoResponseCode.toUpperCase() === "SP4");

  return {
    returnCode:
      apiResponse?.returnCode ??
      response?.returnCode ??
      (isRedirectResponse ? 200 : undefined),
    html,
    url,
    message:
      response?.message ??
      response?.responseMessage ??
      response?.ResponseMessage ??
      apiResponse?.debugMessage ??
      apiResponse?.errorCode,
  };
};

const decodeHtmlDataUrl = (url) => {
  const match = /^data:text\/html(?:;charset=[^;,]+)?;base64,(.*)$/i.exec(
    url ?? ""
  );
  if (!match) {
    return null;
  }

  return decodeURIComponent(
    Array.prototype.map
      .call(atob(match[1]), (character) => {
        return `%${`00${character.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join("")
  );
};

export const loadPowerTranzRedirect = ({ html, url }) => {
  const redirectHtml = html ?? decodeHtmlDataUrl(url);
  if (redirectHtml) {
    document.open();
    document.write(redirectHtml);
    document.close();
    return;
  }

  if (url) {
    window.location.assign(url);
  }
};
